import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    isLoadingRules: false,
    isLoadingAddNewRule: false,
    isLoadingEditRule: false,
    isDeleteRule: false,
    isUploadingRules: false,
    rules: [],
    uploadedRulesVerification: {},
    failedMessage: {},
    count: 0,
    page: 1,
    totalPages: 0,
};

export const rulesSlice = createSlice({
    name: "rules",
    initialState,
    reducers: {
        loadRules: (state) => {
            state.isLoadingRules = true;
            state.rules = [];
        },
        loadedRules: (state, action) => {
            state.isLoadingRules = false;
            state.rules = action.payload.result;
            state.count = action.payload.count;
            state.page = action.payload.page;
            state.totalPages = action.payload.totalPages;
        },
        search: (state, { payload }) => {
            state.page = 1;
            state.vendors = payload;
        },
        addNewRule: (state) => {
            state.isLoadingAddNewRule = true;
        },
        addedNewRule: (state, action) => {
            state.isLoadingAddNewRule = false;
        },
        failedAddedNewRule: (state, action) => {
            state.isLoadingAddNewRule = false;
            state.failedMessage = action.payload
        },
        editRule: (state) => {
            state.isLoadingEditRule = true;
        },
        editedRule: (state, action) => {
            state.isLoadingEditRule = false;
        },
        deleteRule: (state) => {
            state.isDeleteRule = true;
        },
        deletedRule: (state, action) => {
            state.isDeleteRule = false;
        },
        uploadRule: (state) => {
            state.uploadedRulesVerification = {}
        },
        setUploadingRules: (state, { payload }) => {
            state.isUploadingRules = payload
        },
        uploadedRule: (state, action) => {
            state.isUploadingRules = false;
            state.uploadedRulesVerification = action.payload
        },
        setPage: (state, { payload }) => {
            state.page = payload
        },
        updateEditedRule: (state, action) => {
            const updatedRule = action.payload;
            const index = state.rules.findIndex(rule => Number(rule.id) === updatedRule.id);
            if (index !== -1) {
              state.rules[index] = {
                ...state.rules[index],
                multiplier: updatedRule.multiplier,
                company: updatedRule.company,
                investment: updatedRule.investment,
                charge_per_unit: updatedRule.chargePerUnit,
                start_date: updatedRule.dateStart,
                expired_date: updatedRule.dateEnd,
                product_id: updatedRule.productId.toString(),
                product_code: updatedRule.product?.sku || state.rules[index].product_code,
                product_name: updatedRule.product?.name || state.rules[index].product_name,
              };
            }
          },
    },
});
export const rulesActions = rulesSlice.actions;

export default rulesSlice.reducer;
